import React, {useEffect, useState} from "react";
import {
    Button,
    FormCheck,
    FormGroup,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    ModalTitle
} from "react-bootstrap";
import {url} from "../utils/UrlsUtil";
import "../../style/modal/_qr_format_setting_modal.scss";
import {post} from "../utils/FetchUtil.ts";

interface QrFormatSettingModalProps{
    dto: OrderInputTemplateDto | null | undefined;
    show: boolean;
    handleSaved: (entry_dto:any) => void;
    handleClosed: () => void;
}

const QrFormatSettingModal:React.FC<QrFormatSettingModalProps> = (
    {
        dto = {},
        show = false,
        handleSaved = () => {},
        handleClosed = () => {},
    }
) => {
    const [qrImagePath, setQrImagePath] = useState("");
    const initialValues = {
        template_id: undefined,
        template_kbn: "99",
        template_name: "",
        image_path: "",
        wrap_image_path: "",
        inner_noshi: false,
        order_slipnumber: "",
        order_detailnumber: 0,
        qr_format_option_detail: 0,
        qr_style_option_detail: 0,
        transparent_option_detail: 0
    };
    const [qrSettingDto, setQrSettingDto] = useState<OrderInputTemplateDto>(initialValues);
    useEffect( () => {
        if(qrSettingDto.qr_format_option_detail === 1){
            if(qrSettingDto.qr_style_option_detail === 0){
                setQrImagePath(url("/images/qr/png_white.png"));
            }else{
                setQrImagePath(url("/images/qr/seal_white.png"));
            }
        }else{
            if(qrSettingDto.qr_style_option_detail === 0){
                if(qrSettingDto.transparent_option_detail === 0){
                    setQrImagePath(url("/images/qr/png_white.png"));
                }else{
                    setQrImagePath(url("/images/qr/png_transparent.png"));
                }
            }else{
                if(qrSettingDto.transparent_option_detail === 0){
                    setQrImagePath(url("/images/qr/seal_white.png"));
                }else{
                    setQrImagePath(url("/images/qr/seal_transparent.png"));
                }
            }
        }
    }, [qrSettingDto]);
    useEffect(()=>{
        if(show){
            if(dto !== null && dto !== undefined){
                if(dto.template_id !== null && dto.template_id !== -1){
                    post<OrderInputTemplateDto>({
                        action: "/api/template/order_detail/info",
                        data: dto,
                    })
                        .then((data) => {
                            if(data !== null && data !== undefined){
                                setQrSettingDto(cloneDto(data));
                            }
                        })
                        .catch((reason) => {
                            console.log(reason);
                        })
                        .finally(() => {});
                }else {
                    //setQrSettingDto(cloneDto(dto));
                    setQrSettingDto(cloneDto(dto));
                }
            }else{
                setQrSettingDto(initialValues);
            }
        }else {
            setQrSettingDto(initialValues);
        }
    }, [show]);
    const cloneDto = (dto: OrderInputTemplateDto): OrderInputTemplateDto => {
        return {
            template_id: dto.template_id,
            template_kbn: dto.template_kbn,
            template_name: dto.template_name,
            image_path: dto.image_path,
            wrap_image_path: dto.wrap_image_path,
            inner_noshi: dto.inner_noshi,
            order_slipnumber: dto.order_slipnumber,
            order_detailnumber: dto.order_detailnumber,
            //未設定（null）の場合は初期値（0）とする。未選択のまま登録するとサーバーでエラーになるため
            qr_format_option_detail: dto.qr_format_option_detail ?? 0,
            qr_style_option_detail: dto.qr_style_option_detail ?? 0,
            transparent_option_detail: dto.transparent_option_detail ?? 0
        }
    }
    const onChangeSetting = ( evt: React.ChangeEvent<HTMLInputElement> ) => {
        const { name, value } = evt.target;
        const newVal = Number(value);
        setQrSettingDto(prevDto => ({...prevDto, [name]: newVal}));
    }
    const onClickSave = () => {
        handleSaved(createQrEntryDto());
    }
    const createQrEntryDto = () => {
        let templateDto = {
            template_kbn: dto?.template_kbn,
            template_name: "QRフォーマット設定",
        };
        let templateDetails = [];
        templateDetails.push({option_id: 152, option_detail_id: qrSettingDto.qr_style_option_detail});
        templateDetails.push({option_id: 153, option_detail_id: qrSettingDto.qr_format_option_detail});
        if(qrSettingDto.qr_format_option_detail === 1){
            templateDetails.push({option_id: 159, option_detail_id: 0});
        }else{
            templateDetails.push({option_id: 159, option_detail_id: qrSettingDto.transparent_option_detail});
        }
        return {
            template: templateDto,
            detail_list: templateDetails,
            qr_setting: {
                template_kbn: '99',
                qr_style_option_detail: qrSettingDto.qr_style_option_detail,
                qr_format_option_detail: qrSettingDto.qr_format_option_detail,
                transparent_option_detail: qrSettingDto.transparent_option_detail,
                order_slipnumber: dto?.order_slipnumber,
                order_detailnumber: dto?.order_detailnumber
            }
        };
    }
    return (
        <Modal className="qr-format-setting-modal" show={show} onHide={handleClosed} centered>
            <ModalHeader closeButton>
                <ModalTitle><img src={url("/images/logo/geeva_logo.png")}/></ModalTitle>
            </ModalHeader>
            <ModalBody>
                <h2>QRフォーマットの設定</h2>
                <div className="qr-settings-area">
                    <dl>
                        <dt>ファイルスタイル</dt>
                        <dd>
                            <FormGroup className="qr-settings">
                                <FormCheck
                                    inline
                                    type="radio"
                                    id="rdoFileSquare"
                                    name="qr_style_option_detail"
                                    label="正方形"
                                    value={0}
                                    checked={qrSettingDto.qr_style_option_detail === 0}
                                    onChange={onChangeSetting}
                                />
                                <FormCheck
                                    inline
                                    type="radio"
                                    id="rdoFileRectangle"
                                    name="qr_style_option_detail"
                                    label="長方形"
                                    value={1}
                                    checked={qrSettingDto.qr_style_option_detail === 1}
                                    onChange={onChangeSetting}
                                />
                            </FormGroup>
                        </dd>
                    </dl>
                    <dl>
                        <dt>ファイルフォーマット</dt>
                        <dd>
                            <FormGroup className="qr-settings">
                                <FormCheck
                                    inline
                                    type="radio"
                                    id="rdoFormatPng"
                                    name="qr_format_option_detail"
                                    label="PNG"
                                    value={0}
                                    checked={qrSettingDto.qr_format_option_detail === 0}
                                    onChange={onChangeSetting}
                                />
                                <FormCheck
                                    inline
                                    type="radio"
                                    id="rdoFormatPdf"
                                    name="qr_format_option_detail"
                                    label="PDF"
                                    value={1}
                                    checked={qrSettingDto.qr_format_option_detail === 1}
                                    onChange={onChangeSetting}
                                />
                            </FormGroup>
                        </dd>
                    </dl>
                    <dl>
                        <dt>PNGデータの背景</dt>
                        <dd>
                            <FormGroup className="qr-settings">
                                <FormCheck
                                    inline
                                    type="radio"
                                    id="rdoTransparentOn"
                                    name="transparent_option_detail"
                                    label="透過"
                                    value={1}
                                    disabled={qrSettingDto.qr_format_option_detail === 1}
                                    checked={qrSettingDto.transparent_option_detail === 1}
                                    onChange={onChangeSetting}
                                />
                                <FormCheck
                                    inline
                                    type="radio"
                                    id="rdoTransparentOff"
                                    name="transparent_option_detail"
                                    label="白"
                                    value={0}
                                    disabled={qrSettingDto.qr_format_option_detail === 1}
                                    checked={qrSettingDto.qr_format_option_detail === 1 || (qrSettingDto.qr_format_option_detail !== 1 && qrSettingDto.transparent_option_detail === 0)}
                                    onChange={onChangeSetting}
                                />
                            </FormGroup>
                        </dd>
                    </dl>
                </div>
                <div className="qr-preview">
                    <img src={qrImagePath}/>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button variant="secondary" onClick={handleClosed}>キャンセル</Button>
                <Button variant="primary" onClick={onClickSave}>保存</Button>
            </ModalFooter>
        </Modal>
    );
};
export default QrFormatSettingModal;
